import React from "react";
import { Link } from 'react-router-dom';
import { Col, Row, Button, Input } from "reactstrap";
import ToolkitProvider, {
  CSVExport
} from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { useTranslation } from "react-i18next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

// BE status -> FE status
// 0 -> Created
// 1 -> Generating
// 2 -> Generated
// 3 -> Not Generated/Error

const AccountingTable = ({ tableData, searchQuery }) => {
  const { ExportCSVButton } = CSVExport;

  const { t } = useTranslation();

  const statusFormatter = cell => {
    return (
      <>
        {cell === 0 ? (
          <Button className="btn-status" disabled color="primary" style={{maxWidth: "130px"}}>
            {t("accounting.view.table.button.statusCreating")}
          </Button>
        ) : cell === 1 ? (
          <Button className="btn-status" disabled color="warning" style={{maxWidth: "130px"}}>
            {t("accounting.view.table.button.statusGenerating")}
          </Button>
        ) : cell === 2 ? (
          <Button className="btn-status" disabled color="success" style={{maxWidth: "130px"}}>
            {t("accounting.view.table.button.statusGenerated")}
          </Button>
        ) : (
          <Button className="btn-status" disabled color="danger" style={{maxWidth: "130px"}}>
            {t("accounting.view.table.button.statusNotGenerated")}
          </Button>
        )}
      </>
    );
  };

  const actionFormatter = (cell, row) => {
    return (
      <Link to={`/accounting/${row.id}/view`} className="btn btn-outline-primary">{t("accounting.view.table.button.open")}</Link>
    );
  };

  const downloadFormatter = cell =>
  cell ?
  (
    <a href={cell} target="blank">
    <Button className="btn-status" color="primary" style={{maxWidth: "130px"}}>
      <b>{t("accounting.view.table.button.downloadPDF")}</b>
    </Button>
    </a>
  ) : <b>{t("accounting.view.table.button.generatingPDF")}</b>;

  const releaseFormatter = (cell, row) => {
    const SRC = row.release_artwork ? row.release_artwork.thumb_small : null;
    return (
      <div className="flexContainer">
        {SRC && <img style={{width: 40, height: 40, borderRadius: '100%'}} src={SRC} alt={cell}/> }
        <p className="fontWeight700">{cell}</p>
      </div>
    );
  };

  const columns = [
    {
      dataField: "release",
      text: t("accounting.view.table.column.release"),
      sort: true,
      formatter: releaseFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "60px" };
      }
    },
    {
      dataField: "period",
      text: t("accounting.view.table.column.period"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "60px" };
      }
    },
    {
      dataField: "royalties",
      text: t("accounting.view.table.column.royalties"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "60px" };
      }
    },
    {
      dataField: "costs",
      text: t("accounting.view.table.column.costs"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "60px" };
      }
    },
    {
      dataField: "net_revenue",
      text: t("accounting.view.table.column.net_revenue"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "60px" };
      }
    },
    {
      dataField: "status",
      text: t("accounting.view.table.column.status"),
      formatter: statusFormatter,
      sort: true,
      csvExport: false,
      headerStyle: (colum, colIndex) => {
        return { width: "60px" };
      }
    },
    {
      dataField: "report_pdf",
      text: t("accounting.view.table.column.accounting_report"),
      formatter: downloadFormatter,
      headerStyle: (colum, colIndex) => {
        return { width: "60px" };
      }
    },
    {
      dataField: "open",
      text: t("accounting.view.table.column.details"),
      formatter: actionFormatter,
      sort: false,
      csvExport: false,
      headerStyle: (colum, colIndex) => {
        return { width: "20px" };
      }
    }
  ];

  return (
    <ToolkitProvider
      keyField="id"
      data={tableData}
      columns={columns}
      search={{
        searchFormatted: true
      }}
      exportCSV={{
        fileName: 'accounting_reports.csv',
      }}
    >
      {props => (
        <div>
          <Row>
            <Col>
              <div className="customSearch">
                 <Input placeholder={t("accounting.view.table.placeholder.search")}  value={searchQuery.query} style={{marginBottom: 10}} onChange={e => searchQuery.setQuery(e.target.value)} />
              </div>
            </Col>
            <Col>
              <div className="flexEndContainer">

                <ExportCSVButton
                  className="btn btn-outline-info"
                  {...props.csvProps}
                >
                  {t("accounting.view.table.button.exportCsv")}
                </ExportCSVButton>
              </div>
            </Col>
          </Row>

          <BootstrapTable
            {...props.baseProps}
            bordered={ false }
            remote={ { sort: false } }
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

export default AccountingTable;